import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'female-water-fasting': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_water_fasting_health_milestone_kit~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_water_fasting_health_milestone_kit'
					),
			},
			upsell: {
				routeNames: ['upsell-static-subscription-activated', 'upsell-f', 'upsell-static-secret-gift'],
			},
		},
	},
]

export default config
